(() => {
  customElements.whenDefined('dialog-element').then(() => {
    const DialogElement = customElements.get('dialog-element');

    class InspirationModal extends DialogElement {
      constructor() {
        super();
        this._galleryHandles = [];
        this._currentIndex = 0;
        this._savedScrollY = 0;
      }

      get shouldTrapFocus() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this._prevBtn = this.querySelector('[data-prev]');
        this._nextBtn = this.querySelector('[data-next]');
        this._titleEl = this.querySelector('[data-slot="title-line"]');
        this._photoEl = this.querySelector('[data-slot="photographer"]');
        this._stageSlot = this.querySelector('[data-slot="stage"]');
        this._productsSlot = this.querySelector('[data-slot="products"]');
        this._productsWrapper = this.querySelector('[data-products]');

        this._onSelect = this._onSelect.bind(this);
        document.addEventListener('inspiration:select', this._onSelect);

        this._prevBtn?.addEventListener('click', () => this._navigate(-1));
        this._nextBtn?.addEventListener('click', () => this._navigate(+1));

        this.querySelectorAll('[data-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.hide());
        });

        this._onKeydown = this._onKeydown.bind(this);
        this.addEventListener('keydown', this._onKeydown);
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('inspiration:select', this._onSelect);
      }

      _onSelect(event) {
        const handle = event?.detail?.handle;
        if (!handle) return;

        const gallery = document.querySelector('inspiration-gallery');
        if (gallery) {
          this._galleryHandles = Array.from(gallery.querySelectorAll('[data-card]:not([hidden])'))
            .map((c) => c.dataset.handle)
            .filter(Boolean);
          this._currentIndex = this._galleryHandles.indexOf(handle);
          this._gallerySection = gallery.closest('.shopify-section') || gallery;
        } else {
          this._currentIndex = -1;
          this._gallerySection = null;
        }

        if (this._currentIndex === -1) {
          this._galleryHandles = [handle];
          this._currentIndex = 0;
        }

        this._savedScrollY = window.scrollY;

        this._populate(handle);
        this._updateNavState();
        if (this._gallerySection) this._gallerySection.style.display = 'none';
        this.show();
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }

      _navigate(delta) {
        const target = this._currentIndex + delta;
        if (target < 0 || target >= this._galleryHandles.length) return;
        this._currentIndex = target;
        this._populate(this._galleryHandles[target]);
        this._updateNavState();
      }

      _populate(handle) {
        const tpl = this.querySelector(`template[data-inspiration="${CSS.escape(handle)}"]`);
        if (!tpl) return;

        const title = tpl.getAttribute('data-title') || '';
        const designer = tpl.getAttribute('data-designer') || '';
        const photographer = tpl.getAttribute('data-photographer') || '';

        const separator = this.getAttribute('data-designer-separator') || 'by';
        const photoPrefix = this.getAttribute('data-photographer-prefix') || 'Photography by';

        if (this._titleEl) {
          this._titleEl.textContent = designer ? `${title} ${separator} ${designer}` : title;
        }

        if (this._photoEl) {
          if (photographer) {
            this._photoEl.textContent = `${photoPrefix} ${photographer}`;
            this._photoEl.hidden = false;
          } else {
            this._photoEl.textContent = '';
            this._photoEl.hidden = true;
          }
        }

        this._replaceSlot(this._stageSlot, tpl, 'stage');
        this._replaceSlot(this._productsSlot, tpl, 'products');

        if (this._productsWrapper && this._productsSlot) {
          this._productsWrapper.hidden = this._productsSlot.children.length === 0;
        }
      }

      _replaceSlot(slotEl, tpl, fragmentName) {
        if (!slotEl) return;
        const frag = tpl.content.querySelector(`[data-fragment="${fragmentName}"]`);
        if (!frag) {
          slotEl.replaceChildren();
          return;
        }
        const cloned = frag.cloneNode(true);
        slotEl.replaceChildren(...cloned.childNodes);
      }

      _updateNavState() {
        const atStart = this._currentIndex <= 0;
        const atEnd = this._currentIndex >= this._galleryHandles.length - 1;
        if (this._prevBtn) this._prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        if (this._nextBtn) this._nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      _onKeydown(event) {
        if (!this.open) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this._navigate(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this._navigate(+1);
        }
      }

      hide() {
        const result = super.hide();
        if (this._gallerySection) this._gallerySection.style.display = '';
        const savedY = this._savedScrollY;
        Promise.resolve(result).then(() => {
          if (typeof savedY === 'number') {
            window.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
          }
        });
        return result;
      }
    }

    if (!customElements.get('inspiration-modal')) {
      customElements.define('inspiration-modal', InspirationModal);
    }
  });
})();
